<template lang="pug">
a.link.gap-2.align-items-center(
  v-bind="$attrs"
  :href="`mailto:${props.email || props.text}?subject=${props.subject}`"
  rel="noopener noreferrer nofollow"
  target="_blank"
  @click="handleClick"
  :class="[hoverOverrideClass, $attrs.class]"
)
  slot(v-if='$slots.prevLabel' name='prevLabel' :text="props.text")
    | Email:&nbsp;{{ props.text }}
  template(v-else)
    | {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { useGtm } from '@gtm-support/vue-gtm';
import { type EmailDestinationProps } from './EmailDestination.types';
import { emailDestinationDefaults } from './EmailDestination.defaults';
import useSkinDestinationHoverOverride from '../../../../../composables/useSkinDestinationHoverOverride';

const props = withDefaults(
  defineProps<EmailDestinationProps>(),
  emailDestinationDefaults as any,
) as unknown as EmailDestinationProps;

const { hoverOverrideValue, hoverOverrideClass } =
  useSkinDestinationHoverOverride(props as any);

const gtm = useGtm();

function handleClick(event: Event) {
  if (props.isDisabled) {
    event.preventDefault();
    return;
  }

  if (gtm) {
    gtm.trackEvent({
      event: 'email_link',
      value: parseInt('1', 10),
      currency: 'EUR',
      event_category: 'leads',
      event_label: `User Contact by Email`,
    });
  }
}
</script>

<style lang="scss" scoped>
.link {
  &.has-hover-override:hover {
    color: v-bind('hoverOverrideValue') !important;
  }
}
</style>
